import takeRequest from '~/store/takeRequest';
import { getConcession } from './actions';

export function* getConcessionSaga() {
  yield takeRequest(getConcession);
}
